const colors = [
  { borderColor: '#033047', backgroundColor: '#033047' },
  { borderColor: '#00C8E1', backgroundColor: '#00C8E1' },
  { borderColor: '#BFBFBF', backgroundColor: '#BFBFBF' },
  { borderColor: '#E3FF00', backgroundColor: '#E3FF00' },
  { borderColor: '#D9D9D9', backgroundColor: '#D9D9D9' },
  { borderColor: '#033047', backgroundColor: '#033047' },
  { borderColor: '#00C8E1', backgroundColor: '#00C8E1' },
  { borderColor: '#BFBFBF', backgroundColor: '#BFBFBF' },
  { borderColor: '#E3FF00', backgroundColor: '#E3FF00' },
  { borderColor: '#D9D9D9', backgroundColor: '#D9D9D9' },
  { borderColor: '#033047', backgroundColor: '#033047' },
  { borderColor: '#00C8E1', backgroundColor: '#00C8E1' },
  { borderColor: '#BFBFBF', backgroundColor: '#BFBFBF' },
  { borderColor: '#E3FF00', backgroundColor: '#E3FF00' },
  { borderColor: '#D9D9D9', backgroundColor: '#D9D9D9' },
]

export const blue = { borderColor: '#033047', backgroundColor: '#033047' }
export const gray = { borderColor: '#A6A6A6', backgroundColor: '#A6A6A6' }

export default colors
